import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import { FaArrowLeft } from "react-icons/fa6";
import DeleteModal from "../Components/DeleteModal";
import accountTransfersService from "../Services/accountsTransferService";
import { HiOutlineTrash } from "react-icons/hi";
import Head from "../Components/Head";

const JournalTransaction = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const initiateDelete = (id) => {
    setOpen(!open);
    setDeleteID(id);
  };

  const handleDelete = () => {
    setDeleting(true);
    accountTransfersService.deleteAccountTransfer(deleteID).then((res) => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  useEffect(() => {
    setLoading(true);
    accountTransfersService.fetchAllaccountTransfers().then((res) => {
      setData(res.accountTransfers);
      setLoading(false);
    });
  }, [trigger]);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />
      <div>
        {loading ? (
          <div className="">
            <Loading />
          </div>
        ) : (
          <>
            <Head
              heading={"Journal Transaction"}
              button_text={"Add Journal Transaction"}
              navigation={() => navigate("/journal/add")}
            />
            {data && data.length > 0 ? (
              <div className="table-div">
                <table>
                  <thead>
                    <tr className="border-y-2 text-left w-full text-black text-[10px]">
                      <th className="w-[1%] py-4 pl-4">Sr No.</th>
                      <th className="w-[2%] py-4 pl-4">Date</th>
                      <th className="w-[2%] py-4">To Account</th>
                      <th className="w-[2%] py-4 ">From Account</th>
                      <th className="w-[2%] py-4">Amount</th>
                      <th className="w-[7%] py-4">Note</th>
                      <th className="w-[1%] py-4 text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((journal_transaction, index) => (
                      <tr
                        key={index}
                        className="bg-accent border-b border-gray-100 text-left"
                      >
                        <td className="py-4 w-[1%] pl-4 font-bold text-blue-500">
                          {index + 1}.
                        </td>
                        <td className="py-4 w-[2%] pl-4 font-bold">
                          {journal_transaction.date}
                        </td>
                        <td className="py-4 w-[2%]">
                          {journal_transaction?.to_account_title}
                        </td>
                        <td className="py-4 w-[2%]">
                          {journal_transaction.from_account_title}
                        </td>
                        <td className="py-4 w-[2%] font-bold text-teal-600">
                          {parseFloat(journal_transaction.amount).toFixed(2)}{" "}
                          AED
                        </td>
                        <td className="py-4 w-[7%]">
                          {journal_transaction?.note
                            ? journal_transaction.note
                            : "-"}
                        </td>
                        <td className="py-4 w-[1%] text-center">
                          <button
                            onClick={() =>
                              initiateDelete(journal_transaction.id)
                            }
                            className="px-4"
                          >
                            <HiOutlineTrash className="h-4 w-4 text-red-500" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="mt-20">
                <h1 className="font-bold text-2xl text-gray-700 text-center">
                  No Data Found
                </h1>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default JournalTransaction;
